/**
 * Takes a date and returns a new date set to midnight UTC, applying the local timezone offset.
 * If the browser moves a date to a different day due to the timezone offset,
 * this will fix the date to the correct day.
 * @param value Input Date
 */
export const browserDateToMidnightUTC = (value: Date | string | null) => {
	if (!value) {
		return null;
	}
	let date;
	if (typeof value === 'string') {
		date = new Date(value);
	} else {
		date = value;
	}

	const year = date.getFullYear();
	const month = date.getMonth();
	const day = date.getDate();

	return new Date(Date.UTC(year, month, day, 0, 0, 0, 0)).toISOString();
};

export const formatAsOfFilterDate = (value?: Date | string | null): string | undefined =>
	value ? browserDateToMidnightUTC(value) ?? undefined : undefined;

export const formatAsOfFilterDateOnly = (value?: Date | string | null): string | undefined =>
	value ? browserDateToMidnightUTC(value)?.split('T')[0] : undefined;

/**
 * Takes a date and returns a new date set to end of day UTC (23:59:59.999), applying the local timezone offset.
 * @param value Input Date
 */
export const browserDateToEndOfDayUTC = (value: Date | string | null) => {
	if (!value) {
		return null;
	}
	let date: Date;
	if (typeof value === 'string') {
		date = new Date(value);
	} else {
		date = value;
	}

	const year = date.getFullYear();
	const month = date.getMonth();
	const day = date.getDate();

	return new Date(Date.UTC(year, month, day, 23, 59, 59, 999)).toISOString();
};
